var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bsAttrCard"},[_c('div',{staticClass:"bsAttrCard-icon",class:_vm.getIconClass(_vm.label)}),_c('h3',[_vm._v(_vm._s(_vm.label))]),_c('p',{attrs:{"text":_vm.value}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }